import React, { Component } from "react";
import { PropTypes } from "prop-types";
import GripIcon from "@zendeskgarden/svg-icons/src/12/grip.svg";
import { Spinner } from "@zendeskgarden/react-loaders";
import { Menu, Item } from "@zendeskgarden/react-menus";
import EllipsisIcon from "@zendeskgarden/svg-icons/src/26/ellipsis.svg";
import classnames from "classnames";
import t from "@zendesk/client-i18n-tools";
import styles from "./index.css";

const KEY_ENTER = 13;

export default class CategoryRow extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isMoveToModalVisible: false,
    };

    this.onKeyDown = this.onKeyDown.bind(this);
    this.onEditClick = this.onEditClick.bind(this);
    this.onViewClick = this.onViewClick.bind(this);
    this.onMoveToClick = this.onMoveToClick.bind(this);
    this.onModalClose = this.onModalClose.bind(this);
    this.onMoveToTop = this.onMoveToTop.bind(this);
  }

  onKeyDown(e) {
    const { onClick } = this.props;

    if (e.keyCode === KEY_ENTER) {
      onClick();
    }
  }

  onEditClick(e) {
    e.stopPropagation();
    const { category } = this.props;
    window.open(category.edit_url, "_blank");
  }

  onViewClick(e) {
    e.stopPropagation();
    const { category } = this.props;
    window.open(category.html_url, "_blank");
  }

  onMoveToClick(e) {
    e.stopPropagation();
    this.setState({ isMoveToModalVisible: true });
  }

  onMoveToTop(e) {
    e.stopPropagation();

    const { onMoveToTop } = this.props;
    onMoveToTop();
  }

  onModalClose() {
    this.setState({ isMoveToModalVisible: false });
  }

  render() {
    const {
      category,
      testId,
      onClick,
      highlight,
      dragHandleProps,
      saving,
      success,
    } = this.props;

    const menu = (
      <Menu
        data-test-id={testId && `${testId}-menu`}
        trigger={({ ref, isOpen }) => (
          <span
            ref={ref}
            role="button"
            tabIndex={0}
            aria-label={t("knowledge-arrange.section.menuAriaLabel")}
            className={classnames(styles.trigger, {
              [styles.open]: isOpen,
            })}
            data-test-id={testId && `${testId}-menu-trigger`}
            onClick={e => e.stopPropagation()}
          >
            <EllipsisIcon />
          </span>
        )}
      >
        <Item
          data-test-id={testId && `${testId}-edit`}
          onClick={this.onEditClick}
        >
          {t("knowledge-arrange.category.edit")}
        </Item>
        <Item
          data-test-id={testId && `${testId}-move-to-top`}
          onClick={this.onMoveToTop}
        >
          {t("knowledge-arrange.category.sendToTop")}
        </Item>
        <Item
          data-test-id={testId && `${testId}-view`}
          onClick={this.onViewClick}
        >
          {t("knowledge-arrange.category.view")}
        </Item>
      </Menu>
    );

    return (
      <div>
        <div
          tabIndex={0}
          className={classnames(styles.row, {
            [styles.saving]: saving,
            [styles.success]: success,
            [styles.highlight]: highlight,
          })}
          onClick={onClick}
          onKeyDown={this.onKeyDown}
          data-test-id={testId && `${testId}-row`}
        >
          <div
            role="button"
            tabIndex={0}
            className={styles.grip}
            data-test-id={testId && `${testId}-drag-handle`}
            {...dragHandleProps}
          >
            <GripIcon />
          </div>
          <div className={styles.content}>
            <div
              className={styles.name}
              data-test-id={testId && `${testId}-name`}
            >
              {category.name}
            </div>
            <div
              className={styles.additional}
              data-test-id={testId && `${testId}-detail`}
            >
              {t("knowledge-arrange.sectionCount", {
                count: category.section_count,
              })}
            </div>
          </div>

          {saving ? (
            <div className={styles.loader}>
              <Spinner delayMs={0} />
            </div>
          ) : (
            menu
          )}
        </div>
      </div>
    );
  }
}

CategoryRow.defaultProps = {
  highlight: false,
  saving: false,
  success: false,
};

CategoryRow.propTypes = {
  category: PropTypes.shape({
    name: PropTypes.string.isRequired,
    html_url: PropTypes.string.isRequired,
    edit_url: PropTypes.string.isRequired,
  }).isRequired,
  testId: PropTypes.string,
  onClick: PropTypes.func,
  onMoveToTop: PropTypes.func,
  highlight: PropTypes.bool,
  dragHandleProps: PropTypes.object,
  saving: PropTypes.bool,
  success: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/components/CategoryRow/index.js